// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"3863477b5a61cec52a30","691":"49fc89503848b181b6e9","731":"1daab30e50d5a08a2c62","843":"1dcd08e84b4f71a9d0ad"}[chunkId] + ".js";
};